module.exports = __webpack_public_path__ + "img/5.7019965e.png";